Namespace 'Customer.Filters'

class Customer.Filters.FilterListView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/filters"]
  emptyFiltersList: JST["backbone/templates/customer/filters/empty_filters_list"]


  events:
    'click .new-filter': 'createFilter'
    'click .new-folder': 'createFolder'
    'click .settings.filters-header-button': 'toggleSettings'

  initialize: (@options = {}) ->
    @canManage = window.App.Ability.CanManageFilter
    @canManageGlobal = window.App.Ability.CanManageGlobalFilter
    @canSort = window.App.Ability.CanSort

    @dashboardView = @options.dashboardView

    @filters = @options.filters
    @filterEventHandler ||= @options.filterEventHandler
    @filterEventHandler.updateCounters()
    @listenTo(@filters, 'destroy:filter', @renderFilters)
    @listenTo(Backbone, 'filter:collection:fetch', @updateFilter)
    @countersRequestsPending = 0

  render: ->
    @$el.html @template
      canManage: @canManage
      canManageGlobal: @canManageGlobal
      canSort: @canSort
    @$header = @$el.find('#filters-header')
    @$list = @$el.find('#filters-list')
    @alreadyRenderedFilters = []
    @fetchFilters()
    @

  updateFilter: =>
    @filterEventHandler.updateCounters()

  fetchFilters: =>
    @filters.fetch success: (newCollection) =>
      @renderFilters()
      @filterEventHandler.startCounter()
      @trigger('filters:loaded')
      @adjustHeight()

  toggleSettings: ->
    @_keepCustomerSessionAlive()
    @$el.find('#filters-list').toggleClass('with-settings')
    @$el.find('.settings').toggleClass('active')

  createFilter: =>
    @_keepCustomerSessionAlive()
    @openEditModal(new Customer.Filter(name: '', query: {}))

  createFolder: =>
    @_keepCustomerSessionAlive()
    @openEditFolderModal
      folder: new Customer.FilterFolder(),
      isNew: true

  adjustHeight: ->
    @$el.find('#filters-list').css(
      'height',
      "calc(100vh - #{@$header.outerHeight(true) + $('#main-header').outerHeight(true)}px)"
    )

  renderFilters: =>
    return unless @filters.isCollectionChanged(@alreadyRenderedFilters)
    @$list.empty()
    @alreadyRenderedFilters = @filters.getMapIdTree()
    if @filters.models.length > 0
      @renderFilterFolder(@filters.getPublicSection())
      @renderFilterFolder(@filters.getPrivateSection())
    else
      @$list.html @emptyFiltersList()

  renderFilter: (filter, $dom=@$list) ->
    filterView = new Customer.Filters.FilterView(
      filterListView: @
      filter: filter
      canManage: @canManage
      canManageGlobal: @canManageGlobal
      canSort: @canSort
      isSelected: if (@selectedFilter() == filter) then 'selected' else ''
      isColorActive: @_canShowColors()
    )
    $dom.append(filterView.render().el)
    if @canSort
      $dom.sortable({axis: "y", cursor: "move", stop: @_saveFiltersOrder, containment: $dom, handle: '#sortable-button'})

  renderFilterFolder: (filterFolder, $dom=@$list) ->
    filterFolderView = new Customer.Filters.FilterFolderView
      filterListView: @
      filterFolder: filterFolder
      canManage: @canManage
      canManageGlobal: @canManageGlobal
      canSort: @canSort
    filterFolderView.open() if filterFolder.get('open')
    @listenTo filterFolderView, 'edit', (folder) => @openEditFolderModal(folder: folder, isNew: false)
    @listenTo filterFolderView, 'delete', (folder) => @openDeleteFolderModal(folder: folder)
    $dom.append(filterFolderView.render().el)
    if @canSort
      $dom.sortable({axis: "y", cursor: "move", stop: @_saveFiltersOrder, containment: $dom, handle: '#sortable-button'})

  addNewFilter: (filter) =>
    @filters.addFilter(filter)
    @renderFilters()
    @trigger('filter:changed', filter)
    @filterEventHandler.startCounter()

  addNewFolder: (folder) =>
    @filters.addFolder(folder)
    @renderFilters()
    @trigger('filter:changed', folder)

  openEditModal: (filter) ->
    @editFilterView?.remove()
    @editFilterView = new Customer.Filters.EditFilterView
      model: filter,
      data: @options.data,
      canManage: @canManage,
      canManageGlobal: @canManageGlobal,
      availableFolders: @availableFoldersFor(filter)
    @listenTo(@editFilterView, 'delete', @openDestroyAlert)
    @listenTo(@editFilterView, 'save', (newFilter) =>
      @alreadyRenderedFilters = []
      @addNewFilter(newFilter)
    )
    @listenTo(@editFilterView, 'filter:toggleVisibility', (_filter, global) =>
      @editFilterView.updateAvailableFolders(@availableFoldersFor(_filter, global))
    )
    @editFilterView.render()
    @editFilterModalView?.remove()
    @editFilterModalView = new Common.Modals.ModalView
      title: @editFilterView.modal.title
      contentView: @editFilterView
      size:
        width: 1230
        height: 650
    @editFilterModalView.render()
    @listenTo @editFilterModalView, 'modal:closed', @onAnyModalClosed
    @listenTo @editFilterModalView, 'modal:destroyed', => @editFilterView.closeColorPicker()

  openEditFolderModal: ({folder, isNew}) ->
    @editFolderView = new Customer.Filters.EditFolderView
      folder: folder
      isNew: isNew
      canManageGlobal: @canManageGlobal
      availableFolders: @availableFoldersFor folder
    @listenTo(@editFolderView, 'save', (newFolder) => @addNewFolder(newFolder))
    # @listenTo(@editFolderView, 'filterCollection:changed', @trigger('filterCollection:changed'))
    @listenTo(@editFolderView, 'folder:toggleVisibility', (_folder) =>
      @editFolderView.updateAvailableFolders(@availableFoldersFor(_folder))
    )
    @editFolderView.render()
    @editFolderView.modalTab = new App.ModalView
      instance: @editFolderView
      className: 'modal-filters'
      wide: false
    @listenTo(@editFolderView.modalTab, 'modal:closed', @onAnyModalClosed)

  openDeleteFolderModal: ({folder}) ->
    @deleteFolderView = new Customer.Filters.DeleteFolderView(model: folder)
    @listenTo(@deleteFolderView, 'delete', @fetchFilters)
    @listenTo(@deleteFolderView, 'folder:deleted', @triggerFolderDeleted)
    @deleteFolderView.render()
    @deleteFolderView.modalTab = new App.ModalView({instance: @deleteFolderView, wide: false})
    @listenTo(@deleteFolderView.modalTab, 'modal:closed', @onAnyModalClosed)

  triggerFolderDeleted: =>
    Backbone.trigger('filter:collection:fetch', @filters.models)

  openCloneModal: (filter) ->
    name = "#{I18n.t('customer.dashboard.filters.modal.clone.copy_name')} #{filter.attributes.name}"
    newFilter = filter.clone().set({name: name, id: undefined})
    @cloneModalView = new Customer.Filters.CloneFilterView(model: newFilter, globalEditable: @canManageGlobal)
    @listenTo(@cloneModalView, 'save', => @addNewFilter(newFilter))
    @cloneModalView.render()
    @cloneModalView.modalTab = new App.ModalView({instance: @cloneModalView, className: 'modal-filters', wide: true})
    @listenTo(@cloneModalView.modalTab, 'modal:closed', @onAnyModalClosed)
    @

  closeModals: (triggerKeepAlive = true) ->
    @editFilterView.closeModal(triggerKeepAlive) if @editFilterView
    @editFolderView.closeModal(triggerKeepAlive) if @editFolderView
    @deleteFolderView.close(triggerKeepAlive) if @deleteFolderView
    @cloneModalView.closeModal(triggerKeepAlive) if @cloneModalView

  onAnyModalClosed:->
    @_keepCustomerSessionAlive()

  openDestroyAlert: (filter) =>
    swal
      title: 'Delete filter?'
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: 'Yes, delete'
      closeOnConfirm: true
      => @destroyFilter(filter)

  openCantDestroyAlert: (filter) ->
    swal
      title: I18n.t('customer.dashboard.filters.folder.deletion.cant_delete_filter')
      type: 'warning'
      confirmButtonClass: 'btn-danger'
      confirmButtonText: 'Okay'
      closeOnConfirm: true

  destroyFilter: (filter) =>
    $.ajax
      type: 'get'
      dataType: 'JSON'
      url: "/customer/conversations/filters/filter_can_be_deleted/#{filter.get('id')}"
      success: (response) =>
        if response.success
          @trigger('filter:destroyed', filter) if @filters.contains(@selectedFilter())
          filter.destroy()
          @renderFilters()
          Backbone.trigger('filter:collection:fetch', @filters.models)
        else
          @openCantDestroyAlert()

  _canShowColors: ->
    allFilters = @filters.getFilters()
    _.any(allFilters, (filter) -> (filter.get('color')? && filter.get('color')))

  _saveFiltersOrder: () =>
    positions = _.collect(@$list.find('.filter-folder-sortable'), ($filter) -> $filter.dataset.id)
    @filters.saveOrder(positions)

  selectedFilter: ->
    @dashboardView.selectedFilter

  availableFoldersFor: (filterOrFolder, global) ->
    global = filterOrFolder.isGlobal() if (!global || global == null)
    result = if global then @filters.getPublicFoldersFor(filterOrFolder) else @filters.getPrivateFoldersFor(filterOrFolder)
    _.filter(result, (item) -> item.id != filterOrFolder.id)

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
